




import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CvSectionGalleryStoreEdit from '@/store/modules/cvSectionGalleryEdit';
import EditContainer from '@/containers/cv-section-gallery/edit.vue';

const { mapGetters } = createNamespacedHelpers(
  CvSectionGalleryStoreEdit.namespace
);

const fetch = async params => {
  const { cv_id, id } = params;
  await store.dispatch(
    CvSectionGalleryStoreEdit.GetCvSectionGallery.namespaced({
      params: { cv_id, id },
    })
  );
};

export default Vue.extend({
  components: {
    EditContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionGalleryStoreEdit],
    };
  },
  computed: {
    ...mapGetters(['cvSectionGallery']),
  },
});
